import axios from "axios";
import Config from "../../utils/Config";

const authConfig = (accessToken) => ({
  headers: {
    Authorization: accessToken,
    GroupId: localStorage.getItem("groupId") || "",
    CompanyId: localStorage.getItem("companyId") || "",
  },
});

export const isFaqEnabled = () =>
  String(process.env.REACT_APP_FAQ_ENABLED ?? "true").toLowerCase() !== "false";

export const listPublishedFaqs = async (accessToken) => {
  const res = await axios.get(
    `${Config.BACKEND_URL}/api/faq`,
    authConfig(accessToken)
  );
  return Array.isArray(res.data?.data) ? res.data.data : [];
};

export const listAdminFaqs = async (accessToken) => {
  const res = await axios.get(
    `${Config.BACKEND_URL}/api/faq/admin`,
    authConfig(accessToken)
  );
  return Array.isArray(res.data?.data) ? res.data.data : [];
};

export const createFaq = async (accessToken, payload) => {
  const res = await axios.post(
    `${Config.BACKEND_URL}/api/faq`,
    payload,
    authConfig(accessToken)
  );
  return res.data?.data;
};

export const updateFaq = async (accessToken, id, payload) => {
  const res = await axios.put(
    `${Config.BACKEND_URL}/api/faq/${id}`,
    payload,
    authConfig(accessToken)
  );
  return res.data?.data;
};

export const deleteFaq = async (accessToken, id) => {
  const res = await axios.delete(
    `${Config.BACKEND_URL}/api/faq/${id}`,
    authConfig(accessToken)
  );
  return res.data?.data;
};
